import React, { useEffect, useState } from 'react';
import ApplicationDoc from './components/applicationDoc';
import TextFieldContainer from './components/TextFieldContainer';
import PanelMemberComposition from './components/PanelMemberComposition';
import CustomButton from 'components/CustomInput/Button/index';
import AddPanelMemberDialog from './AddPanelMemberDialog';
import { Checkbox, Grid, Paper } from '@material-ui/core';
import {
    ADD_MEETING_ARRANGEMENT_FORM,
    EDIT_MEETING_ARRANGEMENT_FORM,
    GET_MEETING_ARRANGEMENT_FORM_DETAIL,
} from 'store/key';
import { useHistory } from 'react-router';
import useQuery from 'hooks/useQuery';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import useDialog from 'components/ConfirmDialog/useDialog';
import {
    NO_CHAIRMAN,
    CREATED_ARRANGE_MEETING,
    EDITED_ARRANGE_MEETING,
    NO_APPLICATION_DATA,
    EDITED_ARRANGE_MEETING_NOTIFICATION,
} from 'utility/frontendMessage';
const SMainLayout = styled.div`
    height: 100%;
    position: relative;
    overflow: hidden;
`;

const SHeaderLayout = styled.div`
    height: 55px;
    display: flex;
    padding: 0px 15px;
    align-items: center;
    background: #ecebf3;
    overflow: 'hidden';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
`;

const SLayout = styled.div`
    padding: 10px;
    position: absolute;
    left: 0px;
    right: 0px;
    top: ${(props) => props.positionTop}px;
    overflow: auto;
    bottom: 5px;
`;

export default function ReviewArrangement(props) {
    const history = useHistory();
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const [saveData, setSaveData] = useState({
        applicationList: [],
        panelMemberList: [],
        notSendNotification: false,
        typeOfReview: null,
        reviewDueDate: null,
        reviewMeetingDate: null,
        reviewCirculationDate: null,
    });

    const id = useQuery('id');
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);
    const [oldDataDemo, setOldDataDemo] = useState(null);
    const [eidted, setEidted] = useState(false);
    const [emailNotice, setEmailNotice] = useState(false);

    useEffect(() => {
        if (id) {
            dispatch({
                type: GET_MEETING_ARRANGEMENT_FORM_DETAIL,
                payload: {
                    params: { id },
                    callback: (res) => {
                        res?.meetingArrangementFormMember.map((rowData) => {
                            rowData['oldData'] = true;
                        });
                        setOldDataDemo({
                            ...saveData,
                            ...res,
                            applicationList: res?.meetingArrangementFormDocument || [],
                            panelMemberList: res?.meetingArrangementFormMember || [],
                        });
                        setSaveData({
                            ...saveData,
                            ...res,
                            applicationList: res?.meetingArrangementFormDocument || [],
                            panelMemberList: res?.meetingArrangementFormMember || [],
                        });
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let saveDataCopy = JSON.stringify(saveData);
        let oldDataDemoCopy = JSON.stringify(oldDataDemo);
        if (oldDataDemo !== null) {
            let changed = !(oldDataDemoCopy === saveDataCopy);
            if (changed) {
                setEidted(true);
                if (saveData?.panelMemberList) {
                    if (JSON.stringify(saveData?.panelMemberList) !== JSON.stringify(oldDataDemo.panelMemberList)) {
                        setEmailNotice(true);
                    } else {
                        setEmailNotice(false);
                    }
                }
            } else {
                setEidted(false);
                setEmailNotice(false);
            }
            console.log('changed: ', changed);
        }
    }, [saveData]);

    const isEditMode = id === undefined;
    const handleConfirm = () => {
        if (saveData.typeOfReview === null) {
            setForceErrorDisplay(true);
            return;
        }

        let data = { ...saveData, meetingArrangementDocument: [], meetingArrangementMember: [] };
        delete data.applicationList;
        delete data.panelMemberList;
        data.meetingArrangementDocument = saveData.applicationList.reduce(
            (group, curP) =>
                group.concat({
                    documentType: curP.documentType,
                    documentId: curP.documentId,
                    refNo: curP.refNo,
                    confirmedDate: curP.confirmDate,
                }),
            [],
        );
        saveData.panelMemberList.forEach((ele) => {
            data.meetingArrangementMember.push({
                userId: ele.id,
                isChairman: ele.chairman || false,
                panelId: ele?.list?.reduce((group, curP) => group.concat(curP.id), []) || [],
            });
        });
        if (data.meetingArrangementDocument.length === 0) {
            showDialog({
                description: NO_APPLICATION_DATA,
                disableCancelButton: true,
            });
            return;
        }
        // if (
        //     data.meetingArrangementMember.length > 0 &&
        //     !data.meetingArrangementMember.find((item) => item.isChairman)
        // ) {
        //     showDialog({
        //         description: NO_CHAIRMAN,
        //         disableCancelButton: true,
        //     });
        //     return;
        // }
        // console.log(data)

        dispatch({
            type: ADD_MEETING_ARRANGEMENT_FORM,
            payload: {
                data,
                callback: () => {
                    showDialog({
                        description: CREATED_ARRANGE_MEETING,
                        disableCancelButton: true,
                    });
                    history.goBack();
                },
            },
        });
    };
    const NoticeDialog = () => {
        if (emailNotice) {
            showDialog({
                description: EDITED_ARRANGE_MEETING_NOTIFICATION,
                confirmButtonText: 'YES',
                cancelButtonText: 'NO',
            }).then((result) => {
                handleEditConfirm(!result);
            });
        } else {
            handleEditConfirm(false);
        }
    };

    const handleEditConfirm = async (notSendNotification) => {
        if (saveData.typeOfReview === null) {
            setForceErrorDisplay(true);
            return;
        }
        let data = {
            ...saveData,
            notSendNotification: notSendNotification,
            meetingArrangementMember: [],
        };
        delete data.meetingArrangementFormDocument;
        delete data.meetingArrangementFormMember;
        delete data.applicationList;
        delete data.panelMemberList;
        data.meetingArrangementFormId = data.id;
        saveData.panelMemberList.forEach((ele) => {
            if (ele.oldData === undefined) {
                return data.meetingArrangementMember.push({
                    userId: ele.id,
                    isChairman: ele.chairman || false,
                    panelId: ele?.reviewPanel?.reduce((group, curP) => group.concat(curP.id), []) || [],
                });
            }
        });
        dispatch({
            type: EDIT_MEETING_ARRANGEMENT_FORM,
            payload: {
                data,
                callback: () => {
                    showDialog({
                        description: EDITED_ARRANGE_MEETING,
                        disableCancelButton: true,
                    });
                    history.goBack();
                },
            },
        });
    };
    const reset = () => {
        setSaveData({
            applicationList: [],
            panelMemberList: [],
            notSendNotification: false,
            typeOfReview: null,
            reviewDueDate: null,
            reviewMeetingDate: null,
            reviewCirculationDate: null,
        });
    };
    const handleSave = (data) => {
        setSaveData({ ...saveData, ...data });
    };

    return (
        <SMainLayout>
            <Grid style={{ height: '100%', overflow: 'hidden' }}>
                <SHeaderLayout>
                    {isEditMode && (
                        <>
                            <div style={{ marginRight: 15 }}>
                                <CustomButton onClick={handleConfirm}>Confirm</CustomButton>
                            </div>
                            <div style={{ marginRight: 15 }}>
                                <CustomButton onClick={reset}>Reset</CustomButton>
                            </div>
                            <div style={{ marginRight: 15 }}>
                                <CustomButton type="cancel" onClick={() => history.goBack()}>
                                    Cancel
                                </CustomButton>
                            </div>
                        </>
                    )}
                    {!isEditMode && (
                        <>
                            <div style={{ marginRight: 15 }}>
                                <CustomButton onClick={NoticeDialog} disabled={!eidted}>
                                    Confirm
                                </CustomButton>
                            </div>
                            <div style={{ marginRight: 15 }}>
                                <CustomButton type="cancel" onClick={() => history.goBack()}>
                                    Back
                                </CustomButton>
                            </div>
                        </>
                    )}
                </SHeaderLayout>
                <SLayout positionTop={55}>
                    <Paper>
                        <div style={{ padding: 15, paddingBottom: 15 }}>
                            <div>
                                <ApplicationDoc
                                    isEditMode={isEditMode}
                                    applicationList={saveData.applicationList}
                                    handleSave={handleSave}
                                />
                                <div style={{ marginTop: 30 }}>
                                    <TextFieldContainer
                                        isEditMode={isEditMode}
                                        handleSave={handleSave}
                                        saveData={saveData}
                                        forceErrorDisplay={forceErrorDisplay}
                                    />
                                </div>
                                <div style={{ marginTop: 30 }}>
                                    <AddPanelMemberDialog
                                        isEditMode={isEditMode}
                                        handleSave={handleSave}
                                        panelMemberList={saveData.panelMemberList}
                                    />
                                    {isEditMode && (
                                        <div style={{ display: 'flex', alignItems: 'center', marginTop: 15 }}>
                                            <div>
                                                <Checkbox
                                                    color="primary"
                                                    checked={saveData.notSendNotification}
                                                    style={{ padding: 0 }}
                                                    onChange={(e) =>
                                                        setSaveData({
                                                            ...saveData,
                                                            notSendNotification: e.target.checked,
                                                        })
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </div>
                                            <div style={{ marginLeft: 15, fontWeight: 'bold' }}>
                                                Do not send notification and email to all reviewers
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {(saveData.typeOfReview === 0 || saveData.typeOfReview === 1) && (
                                    <div style={{ marginTop: 30 }}>
                                        <PanelMemberComposition memberComposition={saveData.panelMemberList} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </Paper>
                </SLayout>
            </Grid>
        </SMainLayout>
    );
}
